import React from "react";
import { NavLink } from "react-router-dom";
import * as Icons from "lucide-react";
import { MODULES, TID } from "@/constants/testIds";
import { Sheet, SheetContent, SheetHeader, SheetTitle } from "@/components/ui/sheet";

export default function MobileNav({ open, onClose }) {
  return (
    <Sheet open={open} onOpenChange={onClose}>
      <SheetContent side="left" className="w-72 p-0" style={{ background: "hsl(158 47% 12%)" }}>
        <SheetHeader className="px-6 pt-6 pb-4">
          <SheetTitle className="text-white flex items-center gap-2">
            <Icons.Landmark className="h-5 w-5" style={{ color: "hsl(36 43% 55%)" }} />
            <span className="font-serif text-xl">Fonbex</span>
          </SheetTitle>
        </SheetHeader>
        <nav className="px-3 pb-8">
          <ul className="space-y-0.5">
            {MODULES.map((m) => {
              const Icon = Icons[m.icon] || Icons.Circle;
              if (!m.available) {
                return (
                  <li key={m.key}>
                    <div className="sidebar-nav-item disabled" data-testid={TID.sidebarLink(m.key) + "-mobile"}>
                      <Icon className="h-4 w-4" /> <span>{m.label}</span>
                      <span className="ml-auto text-[9px] uppercase tracking-widest" style={{ color: "hsl(36 43% 55%)" }}>Bientôt</span>
                    </div>
                  </li>
                );
              }
              return (
                <li key={m.key}>
                  <NavLink to={m.path} onClick={onClose}
                           className={({ isActive: a }) => `sidebar-nav-item ${a ? "active" : ""}`}
                           data-testid={TID.sidebarLink(m.key) + "-mobile"}>
                    <Icon className="h-4 w-4" /> <span>{m.label}</span>
                  </NavLink>
                </li>
              );
            })}
          </ul>
        </nav>
      </SheetContent>
    </Sheet>
  );
}
